/* eslint-disable no-await-in-loop */
import {
  getIncentiveOfferOperations,
  GetIncentiveOfferOperationsResponse,
} from 'modules/incentivesMarket/api/getIncentiveOfferOperations';

import { IncentiveOfferOperation } from 'modules/incentivesMarket/types';

const OPERATIONS_PAGE_SIZE = 100;

export const fetchAllIncentiveOfferOperations = async ({
  incentiveOfferId,
  societyId,
}: {
  incentiveOfferId: string;
  societyId: string;
}): Promise<IncentiveOfferOperation[]> => {
  let page = 1;
  let totalPages = 1;
  const allItems: IncentiveOfferOperation[] = [];

  do {
    const response: GetIncentiveOfferOperationsResponse =
      await getIncentiveOfferOperations({
        incentiveOfferId,
        societyId,
        page,
        items: OPERATIONS_PAGE_SIZE,
      });

    allItems.push(...(response?.data || []));
    totalPages = Math.ceil((response?.total || 0) / OPERATIONS_PAGE_SIZE) || 1;
    page += 1;
  } while (page <= totalPages);

  return allItems;
};
